import * as ActionType from '../actions/language';

const defaultState = 'EN';

/**
 * @description
 * reducer for language
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function language (state = defaultState, action) {

	let newState = {...state};

	switch (action.type) {

		case ActionType.SET_LANGUAGE : {
			newState = action.countryCode;
			return newState;
		}

		default:
			return state;
	}

}
